import style from "./style.module.scss";
import { FaSpinner } from "react-icons/fa";
import { NavLink } from "react-router-dom";

export default function ButtonLink(props) {
  const { children, size, color, loading = false, disabled = false, className = "", to } = props;
  return (
    <NavLink
      {...props}
      href={to}
      className={`${className} ${style.button}`}
      data-as-navlink={true}
      data-size={size}
      data-color={color}
    >
      {!loading ? children : <FaSpinner color="#fff" className={style._loading} />}
    </NavLink>
  );
}
